export default {
    formatNumber(value) {
        const number = parseFloat(value);
        if (isNaN(number)) {
            return "";
        }
        return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
};
